import { render, staticRenderFns } from "./DetailOrg.vue?vue&type=template&id=22fea0c2&"
import script from "./DetailOrg.vue?vue&type=script&lang=js&"
export * from "./DetailOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports